import { Component, OnInit } from '@angular/core';
import { TimetableService } from '../../services/online.data.service';
import { MonthTimetable } from '../../models/event.model';
import { BookingModalComponent } from '../../gcsetimetable/booking-modal/booking-modal.component';
import { MatDialog } from '@angular/material/dialog';


@Component({
    selector: 'app-online-tests',
    templateUrl: './online-tests.component.html',
    styleUrls: ['./online-tests.component.css'],
    standalone: false
})
export class OnlineTestsComponent implements OnInit {
  months: string[] = [];
  selectedMonth: string = 'Online';
    timetable: MonthTimetable = {};
  
    constructor(private timetableService: TimetableService, private dialog: MatDialog) {}
  
    ngOnInit() {
      this.months = this.timetableService.getMonths();
      this.timetable = this.timetableService.getTimetable();
    }
  
    selectMonth(month: string) {
      this.selectedMonth = month;
    }

     openBookingPopup(examOptions: any) {
          this.dialog.open(BookingModalComponent, {
            data: { examOptions }
          });
        }
  
}
